import { apiClient } from "../services/apiClient";
import { ATP_API_URL } from "../config/apiConfig";

/**
 * Sets ledger required/not-required status for an entity.
 * POST api/Onboarding/set-ledger-status
 *
 * @param {string} entityId  - Entity ID (e.g. "AA0093")
 * @param {"yes"|"no"} status - "yes" = ledger required, "no" = not required
 */
export const setLedgerStatusAction = async (entityId, status) => {
  try {
    const response = await apiClient.post(ATP_API_URL.SET_LEDGER_STATUS, {
      entityId,
      status,
    });

    if (response?.status === 200) {
      return {
        success: true,
        message: response.data?.message || "Ledger status updated",
      };
    }
    return { success: false, message: "Failed to update ledger status" };
  } catch (error) {
    console.error("[SetLedgerStatus] error:", error);
    return {
      success: false,
      message: error.message || "Failed to update ledger status",
    };
  }
};
